import { render, staticRenderFns } from "./MarketType.vue?vue&type=template&id=25300d98&scoped=true"
import script from "./MarketType.vue?vue&type=script&lang=js"
export * from "./MarketType.vue?vue&type=script&lang=js"
import style0 from "./MarketType.vue?vue&type=style&index=0&id=25300d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25300d98",
  null
  
)

export default component.exports